import React, { memo } from 'react';
import { BsSpeedometer2 } from 'react-icons/bs';
import { IoMdTime } from 'react-icons/io';
import { RiCalendar2Line, RiCalendarCheckLine } from 'react-icons/ri';
import { TbCurrencyHryvnia, TbProgressCheck } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { formatDate, formatPrice, formatTime } from '../../utils/formatter';
import IconDetail from '../shared/details/IconDetail';
import Status from '../shared/status/Status';

const VisitInfo = () => {
  const visit = useSelector((state) => state.visit.visit);
  const isMobileView = useSelector((state) => state.screen.isMobileView);
  const tasksPrice = useSelector((state) => state.visitTasks.totalPrice);
  const partsPrice = useSelector((state) => state.visitParts.totalPrice);
  const taskHours = useSelector((state) => state.visitTasks.totalHours);
  const iconSize = isMobileView ? '16' : '24';

  return (
    <>
      <hr />
      <div className="lg:hidden grid grid-cols-2 gap-4 md:gap-0">
        <InfoContainer>
          <IconDetail
            value={<Status status={visit.status} />}
            text="Статус"
            icon={<TbProgressCheck size={iconSize} />}
          />
          <IconDetail
            value={formatDate(visit.startDate)}
            text="Початок робіт"
            icon={<RiCalendar2Line size={iconSize} />}
          />
          <IconDetail
            value={formatDate(visit.endDate)}
            text="Кінець робіт"
            icon={<RiCalendarCheckLine size={iconSize} />}
          />
        </InfoContainer>
        <InfoContainer>
          <IconDetail
            value={visit.mileage ? `${visit.mileage.toLocaleString().replace(/,/g, ' ')} км` : 'Не вказано'}
            text="Пробіг авто"
            icon={<BsSpeedometer2 size={iconSize} />}
          />
          <IconDetail
            value={formatTime(taskHours) + ' н/г'}
            text="Загалом години"
            icon={<IoMdTime size={iconSize} />}
          />
          <IconDetail
            value={formatPrice(tasksPrice + partsPrice) + ' грн'}
            text="Загальна сума"
            icon={<TbCurrencyHryvnia size={iconSize} />}
          />
        </InfoContainer>
      </div>
      <div className="hidden lg:grid grid-cols-3">
        <InfoContainer>
          <IconDetail
            value={<Status status={visit.status} />}
            text="Статус"
            icon={<TbProgressCheck size={iconSize} />}
          />
          <IconDetail
            value={visit.mileage ? `${visit.mileage.toLocaleString().replace(/,/g, ' ')} км` : 'Не вказано'}
            text="Пробіг авто"
            icon={<BsSpeedometer2 size={iconSize} />}
          />
        </InfoContainer>
        <InfoContainer>
          <IconDetail
            value={formatDate(visit.startDate)}
            text="Початок робіт"
            icon={<RiCalendar2Line size={iconSize} />}
          />
          <IconDetail
            value={formatDate(visit.endDate)}
            text="Кінець робіт"
            icon={<RiCalendarCheckLine size={iconSize} />}
          />
        </InfoContainer>
        <InfoContainer>
          <IconDetail
            value={formatTime(taskHours) + ' н/г'}
            text="Загалом години"
            icon={<IoMdTime size={iconSize} />}
          />
          <IconDetail
            value={formatPrice(tasksPrice + partsPrice) + ' грн'}
            text="Загальна сума"
            icon={<TbCurrencyHryvnia size={iconSize} />}
          />
        </InfoContainer>
      </div>
      <Comment comment={visit.comment} />
    </>
  );
};

const InfoContainer = ({ children }) => <div className="flex flex-col gap-4 sm:gap-6 col-span-1">{children}</div>;

const Comment = ({ comment }) => {
  return (
    <>
      <hr />
      <div>
        <div className="text-xs md:text-base font-header1 mb-2">Коментар візиту</div>
        <div className="text-xs md:text-sm break-words whitespace-pre-wrap">{comment || 'Відсутній'}</div>
      </div>
    </>
  );
};

export default memo(VisitInfo);
